export { FiltersSidebarController as FiltersSidebar } from './filters-sidebar-controller';
